import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import pkg from '@package_json';

import { environment } from '@environment';

@Component({
  selector: 'z-version',
  templateUrl: './version.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  version = `${pkg.version}`;
  environment = environment.name;

  language$ = new BehaviorSubject<string>(this.translocoService.getActiveLang());

  constructor(private translocoService: TranslocoService) {}

  ngOnInit() {
    this.translocoService.langChanges$.pipe(takeUntil(this.destroy$)).subscribe((_lang) => {
      this.language$.next(this.translocoService.getActiveLang());
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
